import { indexOf, get, some, size, set } from 'lodash';
import { UserStoreService } from '../services/userStore/UserStoreService';
import { USER_ROLE_CODES } from '../constants/userRoleCodes';
import assign from 'object-assign';
import { EventEmitter } from 'events';

var Dispatcher = require('../dispatcher/appDispatcher');
var ActionType = require('../constants/actionType');
var AccountAction = require('../action/accountAction');
var ErrorHelper = require('../helper/error-helper');


var CHANGE_EVENT = 'change';
var _account = null;
var _disabledActions = [];
var _accountAvatarModalDialogState = false;
var _accountAvatarUploadError = null;


/**
 * Account store
 */
var AccountStore = assign({}, EventEmitter.prototype, {
  addListener: function addListener(callback) {
    this.on(CHANGE_EVENT, callback);
    return {
      remove: () => {
        this.removeListener(CHANGE_EVENT, callback);
      }
    }
  },

  getDispatcher: function () {
    return Dispatcher;
  },

  getDispatchToken: function () {
    return dispatchToken;
  },


  addChangeListener: function (callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener: function (callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  emitChange: function (error, isSavePerformed) {
    this.emit(CHANGE_EVENT, error || null, isSavePerformed);
  },

  /**
   * Get account
   * @returns {*} account data
   */
  getAccount: function () {
    return _account;
  },

  getAccountOrganisationId() {
    return get(_account, 'organisationId');
  },

  getDisabledActions: function () {
    return _disabledActions;
  },

	isActionDisabled(action) {
		const actions = this.getDisabledActions();
		return indexOf(actions, action) >= 0;
	},

  _getRoles() {
    return get(_account, 'roles', [])
  },

  _checkRole(roleName) {
    return some(this._getRoles(), {code: roleName});
  },

  isSuperUser() {
    return this._checkRole(USER_ROLE_CODES.SUPER_USER);
  },

  isOrganisationAdmin() {
    return this._checkRole(USER_ROLE_CODES.ORGANISATION_ADMIN);
  },

  isOrganisationStuff() {
    return this._checkRole(USER_ROLE_CODES.ORGANISATION_STAFF);
  },

  isGovernor() {
    return this._checkRole(USER_ROLE_CODES.GOVERNOR);
  },

  isParent() {
    return this._checkRole(USER_ROLE_CODES.PARENT)
  },

  isGovernorOnly() {
    return this.isGovernor() && size(this._getRoles()) === 1;
  },

	isAvatarModalOpen() {
  	return _accountAvatarModalDialogState;
	},

	avatarUploadError() {
  	return _accountAvatarUploadError;
	},

  setAccount: function (account) {
    _account = account || {};
    _account.isActAs = !!account.originalUserId;
  },

  updateOrganisationLogo(nextOrganisationData) {
    if (!_account) {
      return;
    }
    const organisationLogoUrl = get(nextOrganisationData, 'file.url');
    const organisationName = get(nextOrganisationData, 'name');

    _account = {
      ..._account,
      organisationLogoUrl,
      organisationName
    };
  },

  _updateDisplayName: function () {
    AccountAction.getAccount();
  },

  isActAsMode: function () {
    var account = _account || {};
    var isActAsMode = !!account.originalUserId || false;
    return isActAsMode;
  }
});


var dispatchToken = Dispatcher.register(function (action) {
  switch (action.actionType) {
    case ActionType.PROFILE_GET_ACCOUNT:
      AccountStore.setAccount(action.account);
      UserStoreService.invalidate(action.account.id, AccountStore.isActAsMode());
      AccountStore.emitChange();
      break;

    case ActionType.PROFILE_UPDATE_ACCOUNT:
      AccountStore._updateDisplayName();
      AccountStore.emitChange(null, true);
      break;

		case ActionType.PROFILE_TOGGLE_UPLOAD_AVATAR_DIALOG:
			_accountAvatarModalDialogState = action.state;
			_accountAvatarUploadError = null;
			AccountStore.emitChange(null, true);
			break;

		case ActionType.AVATAR_ULPOAD_SUCCESS:
			set(_account, 'uploadedAvatar', action.avatar);
			_accountAvatarModalDialogState = false;
			_accountAvatarUploadError = null;
			AccountStore.emitChange(null, true);
			break;

		case ActionType.FILE_UPLOAD_IMAGE_UPLOAD_ERROR:
			_accountAvatarUploadError = action.error;
			AccountStore.emitChange(null, true);
			break;

    case ActionType.PROFILE_UPDATE_ACCOUNT_FAILURE:
      var error = ErrorHelper.GetActionError(action.actionType, action.error);
      AccountStore.emitChange(error);
      break;

    case ActionType.GET_ACCOUNT_PERMISSIONS:
      _disabledActions = action.payload;
      AccountStore.emitChange();
      break;

    case ActionType.ORGANISATIONS_UPDATE_ORGANISATION:
      AccountStore.updateOrganisationLogo(action.organisation);
      AccountStore.emitChange();
      break;

    default:
      break;
  }
});

module.exports = AccountStore;

